export default __webpack_public_path__ + "static/media/car-wash.a1089a58.svg";